import { SupportedChainId } from 'constants/chains'

const V2_FACTORY_ADDRESS = '0x347D14b13a68457186b2450bb2a6c2Fd7B38352f'

const DEFAULT_NETWORKS = [SupportedChainId.XDC]

function constructSameAddressMap(address: string, additionalNetworks: SupportedChainId[] = []): AddressMap {
  return DEFAULT_NETWORKS.concat(additionalNetworks).reduce<AddressMap>((memo, chainId) => {
    memo[chainId] = address
    return memo
  }, {})
}

type AddressMap = { [chainId: number]: string }

export const UNI_ADDRESS: AddressMap = {
  ...constructSameAddressMap('0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984'),
  [SupportedChainId.XDC]: '0xf8fC1DA0ac038EA15463dC3BC8476F65E3eB02C9',
  [SupportedChainId.XDC_TESTNET]: '0xE94219d3368C061618eF370E108b3795F5081C70',
}

export const UNISWAP_NFT_AIRDROP_CLAIM_ADDRESS = '0x8B799381ac40b838BBA4131ffB26197C432AFe78' // Uniswap

export const V2_FACTORY_ADDRESSES: AddressMap = {
  ...constructSameAddressMap(V2_FACTORY_ADDRESS),
  [SupportedChainId.XDC_TESTNET]: '0xCae66ac135d6489BDF5619Ae8F8f1e724765eb8f',
}

export const V2_ROUTER_ADDRESS: AddressMap = {
  ...constructSameAddressMap('0xf9c5E4f6E627201aB2d6FB6391239738Cf4bDcf9'),
  [SupportedChainId.XDC_TESTNET]: '0x3F11A24EB45d3c3737365b97A996949dA6c2EdDf',
}

export const PERMIT2_ADDRESS: AddressMap = {
  ...constructSameAddressMap('0x941acf4e2df51bf43c3c4167631dbefa268bc9d7'),
  [SupportedChainId.XDC_TESTNET]: '0x4b722f4a38f97e4078260de0c47f34ae0c404dbf',
}

/* V3 Contract Addresses */
export const V3_CORE_FACTORY_ADDRESSES: AddressMap = {
  [SupportedChainId.XDC]: '0x30f317a9ec0f0d06d5de0f8d248ec3506b7e4a8a',
  [SupportedChainId.XDC_TESTNET]: '0xe91bf417b470ccc6b7307e58a5aa0644572981d7',
}

export const V3_MIGRATOR_ADDRESSES: AddressMap = {
  [SupportedChainId.XDC]: '0x12f6ee73261bc0987c564ded087a022cfa63a6a7',
  [SupportedChainId.XDC_TESTNET]: '0xa8bc88bfd7ff8935e207c9a917b9c46b20b19fa5',
}

export const MULTICALL_ADDRESS: AddressMap = {
  [SupportedChainId.XDC]: '0x6d4393cf8b3adb3534a185d277db0c2ab4bac116',
  [SupportedChainId.XDC_TESTNET]: '0xb6bf4d922c537e1214c1e6fe339135234cd4a8c5',
}

/**
 * The oldest V0 governance address
 */
export const GOVERNANCE_ALPHA_V0_ADDRESSES: AddressMap = constructSameAddressMap(
  '0x5e4be8Bc9637f0EAA1A755019e06A68ce081D58F'
)
/**
 * The older V1 governance address
 */
export const GOVERNANCE_ALPHA_V1_ADDRESSES: AddressMap = {}
/**
 * The latest governor bravo that is currently admin of timelock
 */
export const GOVERNANCE_BRAVO_ADDRESSES: AddressMap = {}

export const TIMELOCK_ADDRESS: AddressMap = constructSameAddressMap('0x1a9C8182C09F50C8318d769245beA52c32BE35BC')

export const MERKLE_DISTRIBUTOR_ADDRESS: AddressMap = {}

export const ARGENT_WALLET_DETECTOR_ADDRESS: AddressMap = {}

export const QUOTER_ADDRESSES: AddressMap = {
  [SupportedChainId.XDC]: '0x4d8a32353c9c25903e771c47e258c051931c2ef5',
  [SupportedChainId.XDC_TESTNET]: '0xbebe711b0bf5a66f651b25aadf0a3a0a57c4cd10',
}

export const NONFUNGIBLE_POSITION_MANAGER_ADDRESSES: AddressMap = {
  [SupportedChainId.XDC]: '0x6d22833398772d7da9a7cbcfdee98342cce154d4',
  [SupportedChainId.XDC_TESTNET]: '0x36131c27b9031ea0032c2635257a70bc5926b9ec',
}

export const ENS_REGISTRAR_ADDRESSES: AddressMap = {}

export const SOCKS_CONTROLLER_ADDRESSES: AddressMap = {}

export const TICK_LENS_ADDRESSES: AddressMap = {
  [SupportedChainId.XDC]: '0xb823682d6b7e794a0dba656a60e7c1d6de52a389',
  [SupportedChainId.XDC_TESTNET]: '0x8dfe961177d66006fe3e785e302e5160b3172ec0',
}

export const UNISWAP_V3_STAKER_ADDRESS: AddressMap = {
  [SupportedChainId.XDC_TESTNET]: '0xe8f8e09ff768095eb7c1489a320e6b964939d451',
  [SupportedChainId.XDC]: '0x326928476f877dcca13dd7d43ce3b0bdb4dcf6f2',
}

export const COMPETITION_ADDRESS: AddressMap = {
  [SupportedChainId.XDC_TESTNET]: '0x4995a6b24A11Dbf0aF2972C8eaDaaaEeA8fB14c7',
  [SupportedChainId.XDC]: '0x4Df55DEe6df1171eBb4F3B589131EB75005DCbCc',
}
